import UpdateForm from "@wielink-application/shared/js/mixins/updateForm.js";
export default UpdateForm;